import { render } from "./AttackArmoryCardComponent.vue?vue&type=template&id=a39af89e&scoped=true"
import script from "./AttackArmoryCardComponent.vue?vue&type=script&lang=js"
export * from "./AttackArmoryCardComponent.vue?vue&type=script&lang=js"

import "./AttackArmoryCardComponent.vue?vue&type=style&index=0&id=a39af89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39af89e"]])

export default __exports__